import { useMutation } from "react-query";
import { PartnerApi } from "../../api/partner.api";
import { useSoldSNStore } from "../../store/soldsn.store";

export const useLetters = () => {
  const setLetters = useSoldSNStore((state) => state.setLetters);

  return useMutation(PartnerApi.soldSNLetters, {
    onSuccess: (data) => {
      setLetters(data);
    },
    onError: (error) => {
      console.error("Login failed:", error);
    },
  });
};
